import {
    Router,
    InternalLink,
    Connector,
    FlatRoute,
    BackboneService,
    TypeColor,
    ConnectorType,
    PolicyRule,
} from './backbone.types';

export const GLOBAL_BW = 10000;
export const GLOBAL_RX_LIMIT = 500;
export const GLOBAL_TX_LIMIT = 2000;

export const typeColors: Record<ConnectorType, TypeColor> = {
    Port: {
        text: 'var(--color-primitive-blue-600)',
        bg: 'var(--color-primitive-blue-50)',
        icon: '\u{1F50C}',
        tagVariant: 'default',
    },
    Cloud: {
        text: 'var(--color-primitive-yellow-700)',
        bg: 'var(--color-primitive-yellow-50)',
        icon: '\u2601\uFE0F',
        tagVariant: 'warning',
    },
    SDhub: {
        text: 'var(--color-primitive-brand-fuchsia-600)',
        bg: 'var(--color-primitive-brand-fuchsia-50)',
        icon: '\u{1F310}',
        tagVariant: 'neutral',
    },
    Fwaas: {
        text: 'var(--color-semantic-fg-danger)',
        bg: 'var(--color-semantic-bg-danger-primary)',
        icon: '\u{1F6E1}',
        tagVariant: 'error',
    },
    Sdwan: {
        text: 'var(--color-semantic-fg-warning)',
        bg: 'var(--color-semantic-bg-warning-primary)',
        icon: '\u{1F310}',
        tagVariant: 'warning',
    },
};

export const routers: Router[] = [
    {
        id: 'ncs-qro1',
        name: 'NCS-5501-QRO1',
        loc: 'KIO QRO1',
        role: 'PE',
        loopback: '100.64.0.1',
        sid: 'fc00:0:1::',
        status: 'up',
    },
    {
        id: 'ncs-gdl1',
        name: 'NCS-5501-GDL1',
        loc: 'KIO GDL1',
        role: 'P',
        loopback: '100.64.0.2',
        sid: 'fc00:0:2::',
        status: 'up',
    },
    {
        id: 'ncs-mty1',
        name: 'NCS-5501-MTY1',
        loc: 'KIO MTY1',
        role: 'P',
        loopback: '100.64.0.3',
        sid: 'fc00:0:3::',
        status: 'up',
    },
    {
        id: 'ncs-mex2',
        name: 'NCS-5501-MEX2',
        loc: 'KIO MEX2',
        role: 'PE',
        loopback: '100.64.0.4',
        sid: 'fc00:0:4::',
        status: 'up',
    },
];

export const internalLinks: InternalLink[] = [
    {
        id: 'l1',
        from: 'ncs-qro1',
        to: 'ncs-gdl1',
        cap: 100,
        bw: 12.4,
        latency: 8.2,
        intf: 'Hu0/0/0/0',
        peerIntf: 'Hu0/0/0/0',
    },
    {
        id: 'l2',
        from: 'ncs-qro1',
        to: 'ncs-mty1',
        cap: 100,
        bw: 8.7,
        latency: 12.5,
        intf: 'Hu0/0/0/1',
        peerIntf: 'Hu0/0/0/0',
    },
    {
        id: 'l3',
        from: 'ncs-qro1',
        to: 'ncs-mex2',
        cap: 100,
        bw: 22.8,
        latency: 4.1,
        intf: 'Hu0/0/0/2',
        peerIntf: 'Hu0/0/0/2',
    },
    {
        id: 'l4',
        from: 'ncs-gdl1',
        to: 'ncs-mty1',
        cap: 100,
        bw: 3.2,
        latency: 14.8,
        intf: 'Hu0/0/0/1',
        peerIntf: 'Hu0/0/0/1',
    },
    {
        id: 'l5',
        from: 'ncs-gdl1',
        to: 'ncs-mex2',
        cap: 100,
        bw: 6.1,
        latency: 10.3,
        intf: 'Hu0/0/0/2',
        peerIntf: 'Hu0/0/0/0',
    },
    {
        id: 'l6',
        from: 'ncs-mty1',
        to: 'ncs-mex2',
        cap: 100,
        bw: 4.5,
        latency: 16.1,
        intf: 'Hu0/0/0/2',
        peerIntf: 'Hu0/0/0/1',
    },
];

export const epData: Connector[] = [
    {
        id: 'EP-001',
        type: 'Port',
        ref: '10-6B8D3F',
        label: 'Port QRO1',
        vrf: 'VRF-CORP-01',
        loc: 'KIO QRO1 (Queretaro)',
        tag: 'Chapultepec',
        vlan: 1010,
        bgp: 'Established',
        rxP: 24,
        txP: 142,
        rxLimit: 100,
        txLimit: 500,
        asn: 65001,
        ip: '10.100.1.1/30',
        peerIp: '10.100.1.2',
        uptime: '45d 12h',
        kp: 60,
        hold: 180,
        md5: true,
        router: 'ncs-qro1',
        portCap: 10000,
        bw: 1340,
        peak: 2100,
        p95: 1890,
        bwHist: [
            1200, 1250, 1340, 1380, 1290, 1310, 1340, 1400, 1520, 1580, 1620,
            1540,
        ],
        routes: [
            {
                pfx: '10.0.1.0/24',
                nh: '10.100.1.2',
                lp: 200,
                med: 0,
                asp: '65001',
                comm: '65001:100',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.0.2.0/24',
                nh: '10.100.1.2',
                lp: 200,
                med: 0,
                asp: '65001',
                comm: '65001:100',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.0.3.0/24',
                nh: '10.100.1.2',
                lp: 200,
                med: 10,
                asp: '65001',
                comm: '65001:200',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.0.4.0/25',
                nh: '10.100.1.2',
                lp: 100,
                med: 20,
                asp: '65001 65010',
                comm: '65001:300',
                org: 'EGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-002',
        type: 'Port',
        ref: '10-9C27A4',
        label: 'Port MEX2',
        vrf: 'VRF-DMZ-01',
        loc: 'KIO MEX2 (Santa Fe)',
        tag: 'San Angel',
        vlan: 1011,
        bgp: 'Established',
        rxP: 18,
        txP: 142,
        rxLimit: 100,
        txLimit: 500,
        asn: 65002,
        ip: '10.100.2.1/30',
        peerIp: '10.100.2.2',
        uptime: '30d 8h',
        kp: 60,
        hold: 180,
        md5: true,
        router: 'ncs-mex2',
        portCap: 10000,
        bw: 980,
        peak: 1800,
        p95: 1620,
        bwHist: [
            820, 870, 920, 980, 1050, 1020, 980, 940, 1080, 1120, 1090, 1060,
        ],
        routes: [
            {
                pfx: '10.10.0.0/16',
                nh: '10.100.2.2',
                lp: 100,
                med: 0,
                asp: '65002',
                comm: '65002:100',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.10.1.0/24',
                nh: '10.100.2.2',
                lp: 100,
                med: 0,
                asp: '65002',
                comm: '65002:100',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '172.20.0.0/16',
                nh: '10.100.2.2',
                lp: 80,
                med: 0,
                asp: '65002 65050',
                comm: '65002:500',
                org: 'EGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-003',
        type: 'Cloud',
        ref: '40-B25D7F',
        label: 'AWS',
        provider: 'AWS',
        cloudAccount: '123456789012',
        cloudRegion: 'us-east-1',
        cloudVPC: 'vpc-0a1b2c3d4e5f',
        vrf: 'VRF-CORP-01',
        loc: 'QRO1 via Megaport',
        tag: 'Chapultepec',
        vlan: 1102,
        bgp: 'Established',
        rxP: 32,
        txP: 142,
        rxLimit: 50,
        txLimit: 200,
        asn: 64512,
        ip: '10.100.10.1/30',
        peerIp: '10.100.10.2',
        uptime: '44d 3h',
        kp: 30,
        hold: 90,
        md5: false,
        router: 'ncs-qro1',
        portCap: 500,
        bw: 285,
        peak: 480,
        p95: 410,
        bwHist: [220, 240, 260, 285, 310, 320, 305, 290, 340, 350, 330, 310],
        routes: [
            {
                pfx: '172.16.0.0/16',
                nh: '10.100.10.2',
                lp: 100,
                med: 0,
                asp: '64512',
                comm: '64512:1000',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '172.16.1.0/24',
                nh: '10.100.10.2',
                lp: 100,
                med: 0,
                asp: '64512',
                comm: '64512:1001',
                org: 'IGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-004',
        type: 'Cloud',
        ref: '40-6E8C41',
        label: 'Oracle',
        provider: 'Oracle',
        cloudAccount: 'ocid1.tenancy.oc1..aaa3kz',
        cloudRegion: 'us-ashburn-1',
        cloudVPC: 'vcn-prod-01',
        vrf: 'VRF-CORP-01',
        loc: 'QRO1 via Equinix',
        tag: 'Chapultepec',
        vlan: 1103,
        bgp: 'Established',
        rxP: 15,
        txP: 142,
        rxLimit: 50,
        txLimit: 200,
        asn: 31898,
        ip: '10.100.11.1/30',
        peerIp: '10.100.11.2',
        uptime: '40d 1h',
        kp: 60,
        hold: 180,
        md5: true,
        router: 'ncs-qro1',
        portCap: 500,
        bw: 120,
        peak: 310,
        p95: 240,
        bwHist: [80, 90, 100, 120, 140, 130, 120, 110, 150, 160, 140, 130],
        routes: [
            {
                pfx: '10.200.0.0/16',
                nh: '10.100.11.2',
                lp: 100,
                med: 0,
                asp: '31898',
                comm: '31898:100',
                org: 'IGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-005',
        type: 'Cloud',
        ref: '40-93F0B2',
        label: 'Azure QRO',
        provider: 'Azure',
        cloudAccount: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        cloudRegion: 'South Central US',
        cloudVPC: 'vnet-backbone-qro',
        vrf: 'VRF-DMZ-01',
        loc: 'QRO1 via Megaport',
        tag: 'Chapultepec',
        vlan: 1104,
        bgp: 'Established',
        rxP: 28,
        txP: 142,
        rxLimit: 50,
        txLimit: 200,
        asn: 12076,
        ip: '10.100.12.1/30',
        peerIp: '10.100.12.2',
        uptime: '38d 6h',
        kp: 60,
        hold: 180,
        md5: false,
        router: 'ncs-qro1',
        portCap: 500,
        bw: 380,
        peak: 495,
        p95: 460,
        bwHist: [
            300, 320, 340, 380, 400, 410, 395, 380, 420, 440, 430, 415,
        ],
        routes: [
            {
                pfx: '10.128.0.0/16',
                nh: '10.100.12.2',
                lp: 100,
                med: 0,
                asp: '12076',
                comm: '12076:51004',
                org: 'IGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-006',
        type: 'Cloud',
        ref: '40-7D19AC',
        label: 'GCP',
        provider: 'GCP',
        cloudAccount: 'ctx-prod-384712',
        cloudRegion: 'us-central1',
        cloudVPC: 'vpc-backbone-01',
        vrf: 'VRF-MGMT-01',
        loc: 'QRO1 via Megaport',
        tag: 'Chapultepec',
        vlan: 1105,
        bgp: 'Active',
        rxP: 0,
        txP: 0,
        rxLimit: 50,
        txLimit: 200,
        asn: 16550,
        ip: '10.100.13.1/30',
        peerIp: '10.100.13.2',
        uptime: '-',
        kp: 60,
        hold: 180,
        md5: false,
        router: 'ncs-qro1',
        portCap: 500,
        bw: 0,
        peak: 0,
        p95: 0,
        bwHist: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        routes: [],
    },
    {
        id: 'EP-007',
        type: 'Cloud',
        ref: '40-8F3D16',
        label: 'Azure MEX',
        provider: 'Azure',
        cloudAccount: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        cloudRegion: 'Central US',
        cloudVPC: 'vnet-backbone-mex',
        vrf: 'VRF-MGMT-01',
        loc: 'MEX2 via Equinix',
        tag: 'San Angel',
        vlan: 1109,
        bgp: 'Established',
        rxP: 25,
        txP: 142,
        rxLimit: 50,
        txLimit: 200,
        asn: 12076,
        ip: '10.100.14.1/30',
        peerIp: '10.100.14.2',
        uptime: '28d 11h',
        kp: 60,
        hold: 180,
        md5: true,
        router: 'ncs-mex2',
        portCap: 500,
        bw: 210,
        peak: 420,
        p95: 380,
        bwHist: [
            160, 170, 190, 210, 230, 240, 225, 210, 250, 260, 245, 235,
        ],
        routes: [
            {
                pfx: '10.128.4.0/22',
                nh: '10.100.14.2',
                lp: 100,
                med: 0,
                asp: '12076',
                comm: '12076:52004',
                org: 'IGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-008',
        type: 'SDhub',
        ref: 'SD-QRO-01',
        label: 'SDhub QRO1',
        vrf: 'VRF-CORP-01',
        loc: 'KIO QRO1',
        tag: 'Chapultepec',
        vlan: 1200,
        bgp: 'Established',
        rxP: 2,
        txP: 142,
        rxLimit: 10,
        txLimit: 500,
        asn: 65100,
        ip: '10.100.20.1/30',
        peerIp: '10.100.20.2',
        uptime: '15d 4h',
        kp: 30,
        hold: 90,
        md5: true,
        router: 'ncs-qro1',
        portCap: 1000,
        bw: 45,
        peak: 120,
        p95: 88,
        bwHist: [30, 32, 38, 45, 50, 48, 45, 42, 55, 58, 52, 48],
        routes: [
            {
                pfx: '0.0.0.0/0',
                nh: '10.100.20.2',
                lp: 50,
                med: 0,
                asp: '65100',
                comm: '65100:999',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.255.0.0/24',
                nh: '10.100.20.2',
                lp: 100,
                med: 0,
                asp: '65100',
                comm: '65100:100',
                org: 'IGP',
                best: true,
            },
        ],
    },
    {
        id: 'EP-009',
        type: 'SDhub',
        ref: 'SD-MEX-01',
        label: 'SDhub MEX2',
        vrf: 'VRF-DMZ-01',
        loc: 'KIO MEX2 (Santa Fe)',
        tag: 'San Angel',
        vlan: 1201,
        bgp: 'Established',
        rxP: 3,
        txP: 142,
        rxLimit: 10,
        txLimit: 500,
        asn: 65101,
        ip: '10.100.21.1/30',
        peerIp: '10.100.21.2',
        uptime: '12d 8h',
        kp: 30,
        hold: 90,
        md5: true,
        router: 'ncs-mex2',
        portCap: 1000,
        bw: 62,
        peak: 180,
        p95: 140,
        bwHist: [40, 45, 50, 62, 70, 68, 62, 58, 75, 80, 72, 68],
        routes: [
            {
                pfx: '0.0.0.0/0',
                nh: '10.100.21.2',
                lp: 50,
                med: 0,
                asp: '65101',
                comm: '65101:999',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.254.0.0/24',
                nh: '10.100.21.2',
                lp: 100,
                med: 0,
                asp: '65101',
                comm: '65101:100',
                org: 'IGP',
                best: true,
            },
            {
                pfx: '10.254.1.0/24',
                nh: '10.100.21.2',
                lp: 100,
                med: 0,
                asp: '65101',
                comm: '65101:101',
                org: 'IGP',
                best: true,
            },
        ],
    },
];

export const allRoutes: FlatRoute[] = epData.flatMap((ep) =>
    ep.routes.map((r) => ({
        ...r,
        src: ep.label,
        srcType: ep.type,
        epId: ep.id,
        vrf: ep.vrf,
        router: ep.router,
    }))
);

export const backboneService: BackboneService = {
    id: 'BB-A1F3C2',
    name: 'Corp-Network-MX',
    status: 'Active',
    vrfs: ['VRF-CORP-01', 'VRF-MGMT-01', 'VRF-DMZ-01'],
    connectorsCount: epData.length,
};

/** Round bandwidth (Mbps) to 3 decimals for display aggregation. */
export const roundBw = (v: number): number => Math.round(v * 1000) / 1000;

export const fmtBw = (v: number): string =>
    v >= 1000 ? `${(v / 1000).toFixed(2)} Gbps` : `${v} Mbps`;

/**
 * Format one Mbps value for connector bandwidth (table / modal):
 * - 0 → `"0.0"`
 * - otherwise at most 4 fractional digits, trailing zeros trimmed
 * @deprecated Prefer {@link formatBandwidthFromMbpsInline}.
 */
export function formatConnectorBandwidthValue(v: number): string {
    if (!Number.isFinite(v)) return '0.0';
    if (v === 0) return '0.0';
    const rounded = Math.round(v * 10000) / 10000;
    let s = rounded.toFixed(4);
    s = s.replace(/(\.\d*?[1-9])0+$/, '$1');
    s = s.replace(/\.0+$/, '');
    if (s === '' || s === '0') return '0.0';
    return s;
}

/** Display unit for a scalar bandwidth when the canonical value is stored in Mbps. */
export type BandwidthScalarUnit = 'Kbps' | 'Mbps' | 'Gbps';

export interface FormatBandwidthFromMbpsResult {
    /** Formatted numeric part only (no unit). */
    value: string;
    unit: BandwidthScalarUnit;
}

/** @deprecated Use {@link BandwidthScalarUnit} */
export type ConnectorBandwidthDisplayUnit = BandwidthScalarUnit;

/** @deprecated Use {@link FormatBandwidthFromMbpsResult} */
export type FormatBandwidthMbpsForDisplayResult = FormatBandwidthFromMbpsResult;

function trimBandwidthNumberString(s: string): string {
    let t = s.replace(/(\.\d*?[1-9])0+$/, '$1');
    t = t.replace(/\.0+$/, '');
    return t === '' || t === '-' ? '0' : t;
}

/**
 * Format a scalar bandwidth whose canonical value is **megabits per second (Mbps)**.
 * - (0, 1) Mbps → **Kbps** (2 fractional digits, trimmed)
 * - [1, 1000) Mbps → **Mbps** (2 fractional digits, trimmed)
 * - ≥ 1000 Mbps → **Gbps** (2 fractional digits, trimmed)
 * - Zero → `0.00` Mbps
 */
export function formatBandwidthFromMbps(mbps: number): FormatBandwidthFromMbpsResult {
    if (!Number.isFinite(mbps) || mbps < 0) {
        return { value: '0.00', unit: 'Mbps' };
    }
    if (mbps === 0) {
        return { value: '0.00', unit: 'Mbps' };
    }
    if (mbps < 1) {
        const kbps = mbps * 1000;
        return {
            value: trimBandwidthNumberString(kbps.toFixed(2)),
            unit: 'Kbps',
        };
    }
    if (mbps >= 1000) {
        const gbps = mbps / 1000;
        return {
            value: trimBandwidthNumberString(gbps.toFixed(2)),
            unit: 'Gbps',
        };
    }
    return {
        value: trimBandwidthNumberString(mbps.toFixed(2)),
        unit: 'Mbps',
    };
}

/** Single-line label e.g. `4.88 Kbps`, `120.5 Mbps`, `1.25 Gbps`. */
export function formatBandwidthFromMbpsInline(mbps: number): string {
    const { value, unit } = formatBandwidthFromMbps(mbps);
    return `${value} ${unit}`;
}

/**
 * Two Mbps scalars shown as `a / b`. If both would format to the same string (e.g. ~10 Gbps vs 10 Gbps)
 * but the values differ, show both in **Mbps** with `decimals` places so small deltas stay visible.
 */
export function formatBandwidthFromMbpsComparePair(
    aMbps: number,
    bMbps: number,
    decimals = 3
): string {
    const left = formatBandwidthFromMbpsInline(aMbps);
    const right = formatBandwidthFromMbpsInline(bMbps);
    if (left === right && Math.abs(aMbps - bMbps) > 1e-12) {
        const aStr = trimBandwidthNumberString(aMbps.toFixed(decimals));
        const bStr = trimBandwidthNumberString(bMbps.toFixed(decimals));
        return `${aStr} Mbps / ${bStr} Mbps`;
    }
    return `${left} / ${right}`;
}

/** @alias {@link formatBandwidthFromMbps} */
export const formatBandwidthMbpsForDisplay = formatBandwidthFromMbps;

/** @alias {@link formatBandwidthFromMbpsInline} */
export const formatBandwidthMbpsInline = (mbps: number): string =>
    formatBandwidthFromMbpsInline(mbps);

/**
 * Smart bandwidth formatter: auto-selects Kbps / Mbps / Gbps
 * and caps the numeric part to at most 4 significant digits.
 */
export const fmtS = (mbps: number): string => {
    if (!Number.isFinite(mbps) || mbps === 0) return "0 Mbps";
    if (mbps >= 1000) return `${Number((mbps / 1000).toPrecision(4))} Gbps`;
    if (mbps < 1) return `${Number((mbps * 1000).toPrecision(4))} Kbps`;
    return `${Number(mbps.toPrecision(4))} Mbps`;
};

export const jitter = (v: number, tick: number, factor = 0.5): number =>
    Math.max(0, v + Math.sin(tick * factor + v * 0.01) * (v * 0.06));

/* ── Policy Rules (mock) ── */
export const policyRules: PolicyRule[] = [
    {
        id: 'PR-001',
        name: 'Cloud to DC Chapultepec',
        from: 'EP-003',
        to: 'EP-001',
        action: 'allow',
        enabled: true,
        priority: 1,
        createdAt: '2024-11-10',
    },
    {
        id: 'PR-002',
        name: 'Azure to SD-WAN QRO',
        from: 'EP-005',
        to: 'EP-008',
        action: 'allow',
        enabled: true,
        priority: 2,
        createdAt: '2024-11-12',
    },
    {
        id: 'PR-003',
        name: 'Block GCP to Any',
        from: 'EP-006',
        to: 'any',
        action: 'deny',
        enabled: true,
        priority: 3,
        createdAt: '2024-11-15',
    },
    {
        id: 'PR-004',
        name: 'DC San Angel to Oracle',
        from: 'EP-002',
        to: 'EP-004',
        action: 'allow',
        enabled: false,
        priority: 4,
        createdAt: '2024-11-18',
    },
    {
        id: 'PR-005',
        name: 'SD-WAN MEX to Azure MEX',
        from: 'EP-009',
        to: 'EP-007',
        action: 'allow',
        enabled: true,
        priority: 5,
        createdAt: '2024-11-20',
    },
];
